import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import { getUser } from '../utilties/userUtilities'
import ChangeCaseSwitcher from '../pages/templates/components/ChangeCaseSwitcher'
import { currentCaseSelector } from '../redux/selectors'
import { isMobile } from '../utilties/mobileDetector'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	headerTopBar: {
		padding: '6px 0',
		[theme.breakpoints.down('sm')]: {
			padding: '15px 0 0 0',
			'& > div': {
				margin: '0 0 15px 0'
			}
        }
	},

}))

const PatientDetailHeader = ({ intl, currentCase }) => {
	const [ user, setUser ] = React.useState(getUser())
	const classes = useStyles();
	const theme = useTheme();
	
	return (
		<Grid
			data-testid="patient-detail-header" direction='row' className={classes.headerTopBar}
			container justify="space-between" alignItems="center" style={{ width: '100%' }}>
			<Grid item xs={12} sm={8}>
				{currentCase && currentCase.protocolName && (
					<Typography
						data-testid="patient-detail-header-protocol"
						variant="h1" style={{
							fontSize: '21px',
							// color: theme.palette.secondary.additional,
							fontWeight: 600
						}}>
						{intl.formatMessage({ id: 'app.patient.protocolHeaderText' })}{' '} {currentCase.protocolName}
					</Typography>)}
			</Grid>
            <Grid item xs={12} sm={4} style={{ textAlign:'right' }} data-print="none">
                <ChangeCaseSwitcher />
            </Grid>
		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
    currentCase: currentCaseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(PatientDetailHeader)
